import React, { SyntheticEvent } from "react";

import IMandant from "../../../types/IMandant";
import InitialSnackbarState from "../../../types/initialData/InitialSnackbarState";
import IPortalCommentList from "../../../types/IPortalCommentList";
import ISnackbarState from "../../../types/ISnackbarState";
import { deleteCommentRequest, loadCommentList, updateCommentRequest } from "../../../xhr/CommentRequests";

export const useCommentListing = (mandant: IMandant) => {
    const [commentList, setCommentList] = React.useState<IPortalCommentList[]>([]);
    const [snackBarState, setSnackBarState] = React.useState<ISnackbarState>({
        ...InitialSnackbarState,
    });

    const closeSnackbar = () => {
        setSnackBarState({ isOpen: false, message: "", type: "success" });
    };

    const fetchComments = React.useCallback(() => {
        loadCommentList(mandant.key)
            .then((result: any) => {
                setCommentList(result.data);
                return Promise.resolve();
            })
            .catch(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Beim Laden der Anfragen ist ein Fehler aufgetreten",
                    type: "error",
                });
            });
    }, [mandant.key]);

    React.useEffect(() => {
        fetchComments();
    }, [fetchComments]);

    const actionMarkAsAswered = (event: SyntheticEvent<HTMLSpanElement>) => {
        const commentId: number = parseInt("" + event.currentTarget.dataset.id);

        const index = commentList.findIndex((search) => {
            return commentId === search.id;
        });

        updateCommentRequest(mandant.key, commentId, {
            flagAccepted: true,
        })
            .then(() => {
                const updatedList = [...commentList];
                updatedList[index].flagAccepted = true;
                setCommentList(updatedList);

                setSnackBarState({
                    isOpen: true,
                    message: "Die Nachricht wurde als beantwortet markiert",
                    type: "success",
                });
            })
            .catch(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Die Nachricht konnte nicht als beantwortet markiert werden",
                    type: "error",
                });
            });
    };

    const actionDeleteComment = (event: SyntheticEvent<HTMLSpanElement>) => {
        const commentId: number = parseInt("" + event.currentTarget.dataset.id);

        deleteCommentRequest(mandant.key, commentId)
            .then(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Die Anfrage wurde erfolgreich gelöscht",
                    type: "success",
                });

                fetchComments();
            })
            .catch(() => {
                setSnackBarState({
                    isOpen: true,
                    message: "Beim Löschen der Anfrage ist ein Fehler aufgetreten",
                    type: "error",
                });
            });
    };

    return {
        commentList,
        snackBarState,
        closeSnackbar,
        actionMarkAsAswered,
        actionDeleteComment,
    };
};
